import {useEffect} from 'react';

import {getPubBeersACS} from 'features/beersManager/requestAC';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';

import Table from '../../Table/Table';

export const BeerListTable = () => {
  const dispatch = useSetGlobalState();

  const {pubBeers, pubBeerFilters} = useGlobalState((state) => state.beersManager);
  const {managedPub} = useGlobalState((state) => state.managedPub);

  useEffect(() => {
    if (managedPub?.id) dispatch(getPubBeersACS({...pubBeerFilters, pubId: managedPub.id}));
    // eslint-disable-next-line
  }, [managedPub?.id, pubBeerFilters.page, pubBeerFilters.perPage]);

  return (
    <div className="list-beers__table">
      <Table beersList={pubBeers} />
    </div>
  );
};
